// extracted by mini-css-extract-plugin
module.exports = {"container":"_2XMDbzaQjloabaaX29IMRu","groupsList":"_3mjOaH5aypAihwq726J0hx"};